export default {
  HEADING_LOGISTICS: 'Logistik Hub',
  RESET_FILTERS: 'Zurücksetzen',
};
